import { thumbArea as viewerThumbArea } from './thumbArea';
import { workArea as viewerWorkArea } from './workArea';

export const mainArea = {

  idDOM: '#work-area-view',

  element: function () {

    return jQuery(mainArea.idDOM);

  },

  clear: function () {

    viewerThumbArea.clear();
    viewerWorkArea.clear();

  },

  hide: function () {

    mainArea.element().hide();

  },

  show: function () {

    mainArea.element().show();

  },

  loading: function () {

    viewerThumbArea.loading();
    viewerWorkArea.loading();

  },



};
